import { CategoryData, ArticleData } from '@/model/faq';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action, State } from 'vuex-class';

@Component
export default class FaqMixin extends Vue {
  @Action('fetchQueriedArticles')
  fetchQueriedArticles!: (queryObj: Record<string, string | number>) => void;

  @Action('setSearch')
  setSearch!: (search: string) => void;

  @Action('resetSearch')
  resetSearch!: () => void;

  @Getter('getArticlesByCategory')
  getArticlesByCategory!: (id: number | string | null) => ArticleData[];

  @Getter('currentArticle')
  currentArticle!: ArticleData;

  @Getter('articles')
  articles!: Record<string, ArticleData[]>;

  @Getter('idMap')
  idMap!: Record<number, string>;

  @Getter('categories')
  categoryList!: CategoryData[];

  @Getter('promoted')
  promoted!: ArticleData[];

  @Getter('loading')
  loading!: Record<string, boolean>;

  @Getter('isChatOffline')
  isChatOffline!: boolean;

  @Getter('loadingSearchPage')
  loadingSearchPage!: boolean;

  @Getter('nextPageRecord')
  nextPageRecord!: Record<string, string | null>;

  @Getter('search')
  search!: string;

  @Getter
  articleNotFound!: boolean;
}
